import React from 'react';
import {
  FormContainer,
  Title,
  FormGroup,
  Label,
  Input,
  Textarea,
  Button,
  PageWrapper
} from './FormStyles';


export const ProjectForm = ({ currentItem, onSubmit, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      title: e.target.title.value.trim(),
      location: e.target.location.value.trim(),
      tags: e.target.tags.value.split(',').map(tag => tag.trim()).filter(Boolean),
      // tags: e.target.tags.value.trim(),
      description: e.target.description.value.trim(),
      images: e.target.images.value.split(',').map(img => img.trim()).filter(Boolean)
    };
    onSubmit(formData);
  };

  return (
    <PageWrapper>
      <FormContainer onSubmit={handleSubmit} noValidate>
      <Title>{currentItem ? 'Edit Project' : 'Add Project'}</Title>
      
      <FormGroup>
        <Label>Title</Label>
        <Input 
          name="title" 
          required 
          defaultValue={currentItem?.title}
        />
      </FormGroup>

      <FormGroup>
        <Label>Location</Label>
        <Input 
          name="location" 
          required 
          defaultValue={currentItem?.location}
        />
      </FormGroup>

      <FormGroup>
        <Label>Tags (comma-separated)</Label>
        <Input 
          name="tags" 
          required 
          defaultValue={currentItem?.tags?.join(', ')}
        />
      </FormGroup>

      <FormGroup>
        <Label>Description</Label>
        <Textarea 
          name="description" 
          required 
          defaultValue={currentItem?.description}
        />
      </FormGroup>

      <FormGroup>
        <Label>Image Path</Label>
        <Input 
          name="images" 
          required 
          defaultValue={currentItem?.images}
        />
      </FormGroup>

      <Button type="submit">
        {currentItem ? 'Update Project' : 'Add Project'}
      </Button>
      <Button type="button" secondary="true" onClick={onClose}>
        Cancel
      </Button>
    </FormContainer>
    </PageWrapper>
  );
};

export const ProductForm = ({ currentItem, onSubmit, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      name: e.target.name.value.trim(),
      price: Number(e.target.price.value),
      description: e.target.description.value.trim(),
      // details: e.target.details.value.trim(),
      // color: e.target.color.value.trim(),
      // materials: e.target.materials.value.split(',').map(m => m.trim()).filter(Boolean),
      images: e.target.images.value.trim()
    };
    onSubmit(formData);
  };

  return (
    <PageWrapper>
      <FormContainer onSubmit={handleSubmit} noValidate>
      <Title>{currentItem ? 'Edit Product' : 'Add Product'}</Title>
      
      <FormGroup>
        <Label>Name</Label>
        <Input 
          name="name" 
          required 
          defaultValue={currentItem?.name}
        />
      </FormGroup>

      <FormGroup>
        <Label>Price</Label>
        <Input 
          name="price" 
          type="number" 
          step="0.01" 
          required 
          defaultValue={currentItem?.price}
        />
      </FormGroup>

      <FormGroup>
        <Label>Description</Label>
        <Textarea 
          name="description" 
          required 
          defaultValue={currentItem?.description}
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Details</Label>
        <Textarea 
          name="details" 
          required 
          defaultValue={currentItem?.details}
        />
      </FormGroup> */}

      {/* <FormGroup>
        <Label>Color</Label>
        <Input 
          name="color" 
          required 
          defaultValue={currentItem?.color}
        />
      </FormGroup> */}

      <FormGroup>
        <Label>Image Path</Label>
        <Input 
          name="image" 
          required 
          defaultValue={currentItem?.image}
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Materials (comma-separated)</Label>
        <Input 
          name="materials" 
          required 
          defaultValue={currentItem?.materials?.join(', ')}
        />
      </FormGroup> */}

      <Button type="submit">
        {currentItem ? 'Update Product' : 'Add Product'}
      </Button>
      <Button type="button" secondary="true" onClick={onClose}>
        Cancel
      </Button>
    </FormContainer>
    </PageWrapper>
   
  );
};

export const EventForm = ({ currentItem, onSubmit, onClose }) => {

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = {
    title: e.target.title.value.trim(),
    date: e.target.date.value,        // ISO string like '2025-08-05'
    time: e.target.time.value,        // string like '14:00'
    location: e.target.location.value.trim(),
    category: e.target.category.value.trim(),
    description: e.target.description.value.trim(),
    image: e.target.image.value.trim()
  };

    console.log("Form Data:", formData); // Debugging line

    onSubmit(formData);
  };

  return (
  <FormContainer onSubmit={handleSubmit} noValidate>
    <Title>{currentItem ? 'Edit Event' : 'Add Event'}</Title>
    
    <FormGroup>
      <Label>Title</Label>
      <Input 
        name="title" 
        required 
        defaultValue={currentItem?.title}
      />
    </FormGroup>

    <FormGroup>
      <Label>Date</Label>
      <Input 
        name="date" 
        type="date" 
        required 
        defaultValue={currentItem?.date}
      />
    </FormGroup>

    <FormGroup>
      <Label>Time</Label>
      <Input 
        name="time" 
        type="time" 
        required 
        defaultValue={currentItem?.time}
      />
    </FormGroup>

    <FormGroup>
      <Label>Location</Label>
      <Input 
        name="location" 
        required 
        defaultValue={currentItem?.location}
      />
    </FormGroup>

    <FormGroup>
      <Label>Category</Label>
      <Input 
        name="category" 
        required 
        defaultValue={currentItem?.category}
      />
    </FormGroup>

    <FormGroup>
      <Label>Description</Label>
      <Textarea 
        name="description" 
        required 
        defaultValue={currentItem?.description}
      />
    </FormGroup>

    <FormGroup>
      <Label>Image Path</Label>
      <Input 
        name="image" 
        required 
        defaultValue={currentItem?.image}
      />
    </FormGroup>

    <Button type="submit">
      {currentItem ? 'Update Event' : 'Add Event'}
    </Button>
    <Button type="button" secondary="true" onClick={onClose}>
      Cancel
    </Button>
  </FormContainer>
  )
};

export const ArtForm = ({ currentItem, onSubmit, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const formData = {
      title: e.target.title.value.trim(),
      description: e.target.description.value.trim(),
      category: e.target.category.value.trim(),
      year: parseInt(e.target.year.value),
      // details: e.target.details.value.trim(),
      techniques: e.target.techniques.value.split(',').map(t => t.trim()).filter(Boolean),
      image: e.target.image.value.trim()
    };

    onSubmit(formData);
  };

  return (
    <FormContainer onSubmit={handleSubmit} noValidate>
      <Title>{currentItem ? 'Edit Art Project' : 'Add Art Project'}</Title>
      
      <FormGroup>
        <Label>Title</Label>
        <Input 
          name="title" 
          required 
          defaultValue={currentItem?.title}
        />
      </FormGroup>

      <FormGroup>
        <Label>Description</Label>
        <Textarea 
          name="description" 
          required 
          defaultValue={currentItem?.description}
        />
      </FormGroup>

      <FormGroup>
        <Label>Category</Label>
        <Input 
          name="category" 
          required 
          defaultValue={currentItem?.category}
        />
      </FormGroup>

      <FormGroup>
        <Label>Year</Label>
        <Input 
          name="year" 
          type="number"
          required 
          defaultValue={currentItem?.year || new Date().getFullYear()}
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Details</Label>
        <Textarea 
          name="details" 
          defaultValue={currentItem?.details}
        />
      </FormGroup> */}

      <FormGroup>
        <Label>Techniques (comma-separated)</Label>
        <Input 
          name="techniques" 
          required 
          defaultValue={currentItem?.techniques?.join(', ')}
          placeholder="e.g., Oil Painting, Digital, Mixed Media"
        />
      </FormGroup>

      <FormGroup>
        <Label>Image URL</Label>
        <Input 
          name="image" 
          required 
          defaultValue={currentItem?.image}
        />
      </FormGroup>

      <Button type="submit">
        {currentItem ? 'Update Art Project' : 'Add Art Project'}
      </Button>
      <Button type="button" secondary="true" onClick={onClose}>
        Cancel
      </Button>
    </FormContainer>
  );
};

export const FurnitureForm = ({ currentItem, onSubmit, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      title: e.target.title.value.trim(),
      description: e.target.description.value.trim(),
      // client: e.target.client.value.trim(),
      // year: parseInt(e.target.year.value),
      details: e.target.details.value.trim(),
      // materials: e.target.materials.value.split(',').map(m => m.trim()).filter(Boolean),
      // dimensions: e.target.dimensions.value.trim(),
      images: e.target.images.value.split(',').map(img => img.trim()).filter(Boolean)
    };
    onSubmit(formData);
  };

  return (
    <FormContainer onSubmit={handleSubmit} noValidate>
      <Title>{currentItem ? 'Edit Furniture Project' : 'Add Furniture Project'}</Title>
      
      <FormGroup>
        <Label>Title</Label>
        <Input 
          name="title" 
          required 
          defaultValue={currentItem?.title}
        />
      </FormGroup>

      <FormGroup>
        <Label>Description</Label>
        <Textarea 
          name="description" 
          required 
          defaultValue={currentItem?.description}
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Client</Label>
        <Input 
          name="client" 
          required 
          defaultValue={currentItem?.client}
        />
      </FormGroup> */}

      {/* <FormGroup>
        <Label>Year</Label>
        <Input 
          name="year" 
          type="number"
          required 
          defaultValue={currentItem?.year || new Date().getFullYear()}
        />
      </FormGroup> */}

      <FormGroup>
        <Label>Details</Label>
        <Textarea 
          name="details" 
          defaultValue={currentItem?.details}
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Materials (comma-separated)</Label>
        <Input 
          name="materials" 
          required 
          defaultValue={currentItem?.materials?.join(', ')}
          placeholder="e.g., Wood, Metal, Glass"
        />
      </FormGroup> */}

      {/* <FormGroup>
        <Label>Dimensions</Label>
        <Input 
          name="dimensions" 
          required 
          defaultValue={currentItem?.dimensions}
          placeholder="e.g., 100cm x 50cm x 75cm"
        />
      </FormGroup> */}

      <FormGroup>
        <Label>Image URL</Label>
        <Input 
          name="images" 
          required 
          defaultValue={currentItem?.image}
        />
      </FormGroup>

      <Button type="submit">
        {currentItem ? 'Update Furniture Project' : 'Add Furniture Project'}
      </Button>
      <Button type="button" secondary="true" onClick={onClose}>
        Cancel
      </Button>
    </FormContainer>
  );
}; 